import { render } from "./LivrateurHeader.vue?vue&type=template&id=899d12d0&scoped=true"
const script = {}

import "./LivrateurHeader.vue?vue&type=style&index=0&id=899d12d0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-899d12d0"]])

export default __exports__